<template>
  <div class="empty-content-component">
    <empty-icon />
  </div>
</template>
<script>
import EmptyIcon from "@/assets/vueIcons/EmptyIcon";
export default {
  components: { EmptyIcon }
};
</script>
<style lang="scss">
.empty-content-component {
  width: 100%;
  height: 100%;
  max-height: 437px;

  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
